import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderLayerComponent } from './components/loaderlayer/loaderlayer.component';
import { DialogContainerComponent } from './components/dialogcontainer/dialogcontainer.component';
import { ConfirmDialogComponent } from './components/confirmdialog/confirmdialog.component';
import { DefaultValuePipe } from './pipes/defaultvalue.pipe';
import { SafeHtmlPipe } from './pipes/safehtml.pipe';
// import { SafeUrlPipe } from "./pipes/safeurl.pipe";
import { RemoveWhiteSpacePipePipe } from "./pipes/removeWhiteSpacePipe.pipe";
import { AssetsPipe } from './pipes/assets.pipe';
import { LocalDatePipe } from './pipes/localdate.pipe'
import { HTTPCLIENT_AUTH_PLUGIN } from './services/httpwithauth';
import { MQService } from './services/mq.service';
import { OAuth2Service, OAuthService } from './services/oauth2.service';
import { ConfigService } from './services/config.service';
import { WindowRef } from './services/window.ref';
import { LocaltimeService } from './services/localtime.service';

@NgModule({
    imports: [CommonModule],
    exports: [LoaderLayerComponent, DialogContainerComponent, ConfirmDialogComponent,
      SafeHtmlPipe, DefaultValuePipe, RemoveWhiteSpacePipePipe, AssetsPipe, LocalDatePipe],
    declarations: [LoaderLayerComponent, DialogContainerComponent, ConfirmDialogComponent,
      SafeHtmlPipe, DefaultValuePipe, RemoveWhiteSpacePipePipe, AssetsPipe, LocalDatePipe],
    providers: [
        HTTPCLIENT_AUTH_PLUGIN, MQService, OAuth2Service, ConfigService, WindowRef, LocaltimeService
    ],
})
export class NgxModule { }
